import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {SponsorshipViewModel} from "../models/sponsorship.view-model";
import {SponsorshipDomainModel} from "../models/sponsorship.domain-model";
import {SponsorshipApiModel} from "../models/sponsorship.api-model";

export class SponsorshipsFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createApiObject(model: SponsorshipApiModel) {
    const apiModel: SponsorshipApiModel = new SponsorshipApiModel(model);

    return apiModel;
  }

  createDomainModel(model: SponsorshipApiModel): SponsorshipDomainModel {
    const domainModel: SponsorshipDomainModel = this.createApiObject(model);

    return domainModel;
  }

  createVM(model: SponsorshipDomainModel): SponsorshipViewModel {
    const viewModel: SponsorshipViewModel = new SponsorshipViewModel(model);

    return viewModel;
  }
}

